export default __webpack_public_path__ + "static/destinationfp-logo-white-762aa9b55706c15a7d989c7ec3fbc0e9.svg";